/**
 * FixHeight module
 *
 * This module wrap an element in a div with scroll
 *
 */

'use strict';

const jQuery = require('jquery');

module.exports.fix = function(content, maxHeight) {
    let wrapScroll;

    if (!(content instanceof jQuery)) {
        throw new Error('content must be an instance of jQuery');
    }

    wrapScroll = content.parent();

    if (!wrapScroll.hasClass('cloud-scroll')) {
        wrapScroll = content.wrap(jQuery('<div class="cloud-scroll"></div>')).parent();
        jQuery(wrapScroll).on('mousewheel DOMMouseScroll', function(e) {
            let $target = jQuery(e.target);

            if ($target.parent('li').parent('ul.ui-autocomplete').length === 0) {
                let height = jQuery(this).outerHeight();
                let d = Math.max(-1, Math.min(1, (e.originalEvent.wheelDelta || -e.originalEvent.detail)));

                if((this.scrollTop === (this.scrollHeight - height) && d < 0) || (this.scrollTop === 0 && d > 0)) {
                    e.preventDefault();
                }
            }
        });
    }

    wrapScroll.css({'maxHeight': maxHeight, 'overflowX': 'hidden', 'overflowY': 'auto'});
};
